import { memo } from "react";

import { FooterColumn, LinkSection } from "./LinkSection";
import { LinkGrid } from "./styles";

interface FooterLinksProps {
  sections: FooterColumn[];
}

export const FooterLinks = memo(({ sections }: FooterLinksProps) => {
  return (
    <LinkGrid>
      {sections.map((section) => (
        <LinkSection key={section.id} section={section} />
      ))}
    </LinkGrid>
  );
});
FooterLinks.displayName = "FooterLinks";
